import { useQuery } from '@tanstack/react-query'

import { graphql_multi_call as graphql_admin_multi_call } from '../../schemas/server_admin_query.ts'

import { query_admin_assets } from './fund_graphql.ts'
import type { AdminAssetsResponse } from './fund_queries.ts'
import { keys } from './keystore.ts'

export function useAdminAssets() {
  return useQuery({
    queryKey: keys.admin_assets.all.queryKey,
    queryFn: async (): Promise<AdminAssetsResponse | null> => {
      try {
        const response = await graphql_admin_multi_call({
          query: query_admin_assets,
          variables: {},
        })

        return response satisfies AdminAssetsResponse
      } catch (error) {
        console.error('Error fetching all assets:', error)
        return null
      }
    },
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  })
}
